export const BASE_URL =
	// eslint-disable-next-line no-undef
	process.env.NODE_ENV === "development"
		? /* "https://paivitystesti.paas.datacenter.fi/" */ "https://kehitys.tologo.fi/"
		: "https://api.tologo.fi/";
